import { render, staticRenderFns } from "./CrudSubmissions.vue?vue&type=template&id=6336f77c&"
import script from "./CrudSubmissions.vue?vue&type=script&lang=js&"
export * from "./CrudSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports